import { render, staticRenderFns } from "./HomeBannerTemplate.vue?vue&type=template&id=2f8a4a07"
import script from "./HomeBannerTemplate.vue?vue&type=script&lang=ts"
export * from "./HomeBannerTemplate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports